const equipmentsByPlace = {
  word1:'mostrando',
  word2:'de',
  word3:'equipo'
}

export default equipmentsByPlace;
